// extracted by mini-css-extract-plugin
export default {"subTitle":"styles_subTitle__bGeR6","spanLeft":"styles_spanLeft__tOG0g","mL30":"styles_mL30__uIK3n","mL60":"styles_mL60__fMig-"};